import apiPaths from '../../api-paths';

export default {
  upload(file) {
    const formData = new FormData();
    formData.append('image', file);

    return axios.post(`${ apiPaths.API }/crms/public-images`,
      formData,
      { 'Content-Type': 'multipart/form-data' }
    );
  },
};
